module.exports = __webpack_public_path__ + "img/programme3.4ad3a070.png";